import { render, staticRenderFns } from "./Onboarding3.vue?vue&type=template&id=89a33398&scoped=true"
import script from "./Onboarding3.vue?vue&type=script&lang=js"
export * from "./Onboarding3.vue?vue&type=script&lang=js"
import style0 from "./Onboarding3.vue?vue&type=style&index=0&id=89a33398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a33398",
  null
  
)

export default component.exports